export const getUserFullName = (users, userId) => {
    if (users.length > 0 && userId) {
        const user = users.find((user) => user.id === userId);
        
        return user ? `${user.first_name} ${user.last_name}` : '';
    }
    
    return '';
}